import {getCookie, getUserInfoFromCache} from '@/common/js/utils.js';

/**
 * 全局state
 * token: token
 * backurl: 重新登陆后跳转url
 * user: 缓存的user
 * wxUrl: 微信jssdk验证地址
 * verifyCodeTime: 验证码倒计时
 * isVerifyCodeReady: 发送验证码状态
 * isStartClass: 是否正在训练
 * isEndClass: 是否手动结束训练
 * startClassRecordId: 训练中的recordId
 * loadingCount: loading的数量
 */
const state = {
	token: getCookie('token'),
	backurl: getCookie('backurl'),
	user: getUserInfoFromCache(),
	wxUrl: '',
	verifyCodeTime: 60,
	isVerifyCodeReady: true,
	isStartClass: false,
	isEndClass: false,
	startClassRecordId: '',
	loadingCount: 0
};

export default state;



// WEBPACK FOOTER //
// ./src/store/state.js